import moment from 'moment';

export const premiumFormat = (value: number) => {
    return new Intl.NumberFormat('uk', {minimumFractionDigits: 2}).format(value);
};

export const sumInsuredFormat = (value: number) => {
    return new Intl.NumberFormat('uk', {minimumFractionDigits: 0}).format(value);
};

export const discountPercentFormat = (value: number) => {
    return new Intl.NumberFormat('uk', {minimumFractionDigits: 0, maximumFractionDigits: 0, style: "percent"}).format(value);
};

export const dateFormat = (value: Date) => {
    moment.locale('uk');
    return moment(value).format('L');
};

export const format = (value: string, pattern: string) => {
    let i = 0,
        v = value.toString();
    return pattern.replace(/#/g, _ => v[i++]);
}